import { MailMessage } from "../types/mail";
import { MailMessageDto } from "../models/MailMessageDto";

export const toMailMessage = (dto: MailMessageDto | MailMessage): MailMessage => {
    // Если объект уже в формате MailMessage (содержит documentId), возвращаем его как есть.
    if ('documentId' in dto && typeof dto.documentId === 'string') {
        return dto as MailMessage;
    }
    
    // Если объект содержит knowledgeItemId (camelCase), преобразуем его в documentId
    if ('knowledgeItemId' in dto && typeof dto.knowledgeItemId === 'string') {
        return {
            ...dto,
            documentId: dto.knowledgeItemId
        } as MailMessage;
    }
    
    // Преобразуем DTO (PascalCase) в MailMessage (camelCase)
    const pascalDto = dto as MailMessageDto;
    
    return {
        id: pascalDto.Id,
        senderUsername: pascalDto.SenderUsername,
        recipientUsername: pascalDto.RecipientUsername,
        documentId: pascalDto.KnowledgeItemId,
        documentTitle: pascalDto.DocumentTitle,
        text: pascalDto.Text,
        status: pascalDto.Status,
        createdAt: pascalDto.CreatedAt,
        updatedAt: pascalDto.UpdatedAt,
        senderName: pascalDto.SenderName,
        recipientName: pascalDto.RecipientName
    };
}; 